var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgExpandHeight = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.006 18.251 3.471-3.388a.87.87 0 0 1 .627-.262.87.87 0 0 1 .627.262.84.84 0 0 1 .269.624.84.84 0 0 1-.269.622l-3.449 3.388q-.514.503-1.276.503c-.762 0-.933-.168-1.277-.503L7.26 16.11a.8.8 0 0 1-.26-.623.88.88 0 0 1 .28-.624.88.88 0 0 1 .64-.262q.369 0 .637.262zm0-12.502L8.557 9.115a.83.83 0 0 1-.627.252.95.95 0 0 1-.627-.252.88.88 0 0 1-.28-.623.8.8 0 0 1 .258-.623l3.449-3.366Q11.244 4 12.006 4c.762 0 .933.168 1.277.503l3.448 3.366q.27.263.258.623a.88.88 0 0 1-.28.623.96.96 0 0 1-.627.252.83.83 0 0 1-.627-.252z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExpandHeight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/expand-height.78e8893b.svg";